import React, { Component } from "react";
import { db } from "../../firebase-config";
import {
  collection,
  getDocs,
  doc,
  setDoc,
  addDoc,
  query,
  where,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";

import { Link } from "react-router-dom";
import { useState } from "react";
import { FiExternalLink } from 'react-icons/fi';
import styles from "./WebPushRegister2.module.css";
import { ReactComponent as LogoOfertas } from "../../assets/ic_linkred.svg";
import Modal from "react-modal";
import { formatDate, orderByTimestampDin } from "../../utils/standaloneUtils";
import { checkPermissions } from "../../utils/standaloneUtils";
import { UserContext } from "../../UserContext";
import DefaultButton from "../../Components/forms/DefaultButton";

var abc = [];
var selectedItems = [];

const WebPushAgendamentos2 = () => {
  const [audience, setAudience] = React.useState("");
  const [title, setTitle] = React.useState(""); //conteúdo
  const [body, setBody] = React.useState("");
  const [dateSchedule, setDateSchedule] = React.useState("");
  const [url, setUrl] = React.useState("");
  const [dateSend, setDateSend] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [img, setImg] = React.useState("");
  const [docID, setDocID] = React.useState("");
  const [showForm, setShowForm] = React.useState(false);
  const [showTable, setShowTable] = React.useState(true);
  const [showBtSave, setShowBtSave] = React.useState(false);
  const [showBtUpdate, setShowBtUpdate] = React.useState(false);

  const [showBtEdit, setShowBtEdit] = React.useState(false);
  const [showBtDelete, setShowBtDelete] = React.useState(false);
  const [showBtAddNew, setShowBtAddNew] = React.useState(true);

  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenMsg, setIsOpenMsg] = React.useState(false);
  const [txtModal, setTxtModal] = React.useState("");

  const [disabledBanner, setDisabledBanner] = useState(false);
  const [disabledNotification, setDisabledNotification] = useState(false);

  const { data, permission, modules } = React.useContext(UserContext);

  //const imgExemple = require("../assets/logo.png");
  const initialData = [
    {
      audience: "Carregando...",
      title: "Carregando...",
      body: "Carregando...",
      url: "Carregando...",
      dateSchedule: "Carregando...",
      dateSend: "Carregando...",
      status: "Carregando...",
      img: "Carregando...",
    },
  ];

  const [allData, setAllData] = React.useState(initialData);

  React.useEffect(() => {
    getAll();
  }, []);

  async function getAll() {
    let dataGroup = [];
    let indice = 0;

    const q = collection(db, "agendamentos-web-push");
    const snap = await getDocs(q);
    snap.forEach((doc) => {
      dataGroup.push(doc.data());
      dataGroup[indice]["docID"] = doc.id;
      indice = indice + 1;
    });
    dataGroup = orderByTimestampDin(dataGroup, 'dateSend')

    setAllData(dataGroup);
  }

  function onRequestClose() {
    setIsOpen(false);
  }

  function onRequestCloseMsg() {
    setIsOpenMsg(false);
  }

  function disableForm(e) {
    if (e.target.value == "banner") {
      setDisabledNotification(false);
      setDisabledBanner("disabled");
    } else if (e.target.value == "notificacao") {
      setDisabledNotification("disabled");
      setDisabledBanner(false);
    } else {
      setDisabledBanner(false);
      setDisabledNotification(false);
    }
  }

  function handleUpdateData() {
    const updateRef = doc(db, "oferta-contextual", docID);
    // Atomically increment the population of the city by 50.
    updateDoc(updateRef, {
      audience: audience,
      title: title,
      body: body,
      url: url,
      dateSchedule: dateSchedule,
      dateSend: dateSend,
      status: status,
      img: img,
    }).then(function () {
      setShowForm(false);
      setShowBtAddNew(true);
      setShowTable(true);
      getAll();
      setShowBtEdit(false);
      setShowBtDelete(false);
      setTxtModal("Item atualizado com sucesso.");
      setIsOpenMsg(true);
    });
  }

  // valida se existe uma oferta do mesmo produto e espaço comercial ativa
  async function checkIfExist(next) {
    //const q = collection(db, 'oferta-contextual');
    let q = "";
    if (status == "ativo") {
      q = query(
        collection(db, "oferta-contextual"),
        where("status", "==", "ativo"),
        where("espacoComercial", "==", espacoComercial),
        where("produto", "==", produto),
        where("txtConteudo", "!=", txtConteudo)
      );
    }

    if (status == "preview") {
      q = query(
        collection(db, "oferta-contextual"),
        where("status", "==", "preview"),
        where("espacoComercial", "==", espacoComercial),
        where("produto", "==", produto),
        where("txtConteudo", "!=", txtConteudo)
      );
    }

    let qtd = 1;

    if (status != "inativo") {
      // só faz a consulta se o status for nao for inativo
      const snap = await getDocs(q);
      if (snap.size >= qtd) {
        alert(
          "Não foi possível realizar a operação, já existe uma campanha ativa para esse produto!"
        );
      } else {
        if (next == "add") {
          handleAddBQ();
        }
        if (next == "update") {
          handleUpdateData();
        }
      }
    }
    if (status == "inativo") {
      // se for inativo sempre salva ou atualiza o item
      if (next == "add") {
        handleAddBQ();
      }
      if (next == "update") {
        handleUpdateData();
      }
    }
  }

  // function handleDeleteData() {
  //   setDocID(
  //     event.target.parentNode.parentNode.getElementsByTagName("span")[0]
  //       .innerHTML
  //   );
  //   deleteDoc(
  //     doc(
  //       db,
  //       "oferta-contextual",
  //       event.target.parentNode.parentNode.getElementsByTagName("span")[0]
  //         .innerHTML
  //     )
  //   ).then(function () {
  //     alert("Item deletado!");
  //     getAll();
  //     setShowForm(false);
  //     setShowTable(true);
  //   });
  // }

  function deleteDataMultipleItems() {
    selectedItems.forEach(function (item) {
      deleteDoc(doc(db, "agendamentos-web-push", item)).then(function () {
        setIsOpen(false);
        setTxtModal("Exclusão realizada com sucesso.");
        setIsOpenMsg(true);
        getAll();
        setShowForm(false);
        setShowBtAddNew(true);
        setShowTable(true);
      });
    });

    // limpa checkboxes selecionados
    var checkboxes = document.querySelectorAll("input[type=checkbox]:checked");
    for (var checkbox of checkboxes) {
      checkbox.checked = false;
    }
  }

  function handleCancel() {
    setShowForm(false);
    setShowBtAddNew(true);
    setShowTable(true);
  }

  function handleCheckbox() {
    selectedItems = [];
    var tempSelectedItems = [];
    var checkboxes = document.querySelectorAll("input[type=checkbox]:checked");

    for (var i = 0; i < checkboxes.length; i++) {
      tempSelectedItems.push(checkboxes[i].value);
      selectedItems = tempSelectedItems;
    }

    abc = tempSelectedItems;

    var checkboxes = document.querySelectorAll("input[type=checkbox]:checked");
    for (var checkbox of checkboxes) {
      checkbox.checked = true;
    }
    if (selectedItems.length >= 1) {
      setShowBtDelete(true);
    } else if (selectedItems.length <= 0) {
      setShowBtDelete(false);
    }
  }

  function formatSecondsToDate(date) {
    let dateFormated;
    let t;
    let seconds;
    try {
      seconds = date.split("seconds=")[1].split(",")[0];
      t = new Date(1970, 0, 1); // Epoch
      t.setSeconds(seconds);
      dateFormated =
        t.getDate() +
        "/" +
        t.getMonth() +
        "/" +
        t.getFullYear() +
        " " +
        Number(t.getHours() - 3) +
        ":" +
        t.getMinutes();
    } catch (e) {
      dateFormated = "vazio";
    }

    return dateFormated;
  }

  const upperButtons = () => {
    if (checkPermissions('web_push', modules, permission) > 2)

      return (
        <div className={`${styles.flexboxRow} ${styles.flexend} mt-2 mb-3`}>

          <DefaultButton
            type={!showBtDelete ? "disabled" : "red"}
            size="XL"
            onClick={() => { setIsOpen(true) }
            }
            children="Excluir"
          />


          {showBtAddNew == true && (
            <Link className={styles.linkWebPush} to="/web-push">
              <DefaultButton
                type={"red"}
                size="XL"
                // onClick={() => { getPrevPage() }
                // }
                children="Adicionar"
              />
            </Link>
          )}
        </div>
      )
  }

  const translate = {
    "monthly": "mensal",
    "weekly": "semanal",
    "daily": "diário"
  }

  const formatHours = (brokenHour) => {
    Number.prototype.zeroPad = function () {
      return ('0' + this).slice(-2);
    };
    const timeArr = brokenHour.split(':')
    const hours = parseInt(timeArr[0])
    const minutes = parseInt(timeArr[1])
    return `${hours.zeroPad(2)}:${minutes.zeroPad(2)}`
  }

  const getWeekdayByNumber = (numberArr) => {
    const translateWeekday = {
      1: "Domingo",
      2: "Segunda",
      3: "Terça",
      4: "Quarta",
      5: "Quinta",
      6: "Sexta",
      7: "Sábado",
    }
    let weekDayString = ''
    numberArr.forEach((day) => weekDayString += (translateWeekday[day] + ", "))
    return weekDayString.slice(0,-2)
  }

  const recurrenceTooltip = (dataReference) => {

    switch (dataReference.recurrence) {
      case 'daily':
        return `Todo dia ás ${formatHours(dataReference.recurrenceSendPost)}`;

      case 'weekly':

        return `${getWeekdayByNumber(dataReference.recurrenceCheckboxWeekly)} ás ${formatHours(dataReference.recurrenceTime)}`;

      case 'monthly':

        return `Todo dia ${dataReference.recurrenceDayMonth} ás ${formatHours(dataReference.recurrenceTime)}`;
    }
  }


  return (
    <main className="container">
      <div className="container-page">
        <Modal
          isOpen={isOpen}
          ariaHideApp={false}
          contentLabel="Selected Option"
          overlayClassName="react-modal-overlay-logout"
          className="react-modal-content-logout"
          onRequestClose={onRequestClose}
        >
          {" "}
          <button
            className="react-modal-close"
            type="button"
            onClick={onRequestClose}
          >
            <span>&#x2715;</span>
          </button>
          <div className={styles.contentModal}>
            <h2>Deseja excluir os itens selecionados?</h2>
            <div className={styles.contentModalBtn}>
              <button
                onClick={function (event) {
                  deleteDataMultipleItems();
                }}
              >
                Sim
              </button>
              <button onClick={onRequestClose}>Não</button>
            </div>
          </div>
        </Modal>

        <section className={`${styles.sectionWebPush} container`}>
          <div className={`${styles.titleAdjust}`}>
            <LogoOfertas />
            <h1> Agendamentos </h1>
            {upperButtons()}
          </div>

          {/* <a href="https://www.santander.com.br/?oferta-contextual=preview">
            Preview
          </a> */}

          {showTable && (
            <div className={styles.tabela}>
              <table>
                <thead>
                  <tr>
                    <th>{/* <input type="checkbox" /> */}</th>
                    <th>Audiencia</th>
                    <th>Título</th>
                    <th>Conteúdo</th>
                    <th>Data do agendamento</th>
                    <th>Link</th>
                    <th>Status</th>
                    <th>Recorrência</th>
                  </tr>
                </thead>

                <tbody>
                  {allData.map((dataItem) => (
                    <tr>
                      <td >
                        <input
                          type="checkbox"
                          value={dataItem.docID}
                          onClick={function (event) {
                            handleCheckbox(event);
                          }} />
                        <span className={styles.uuid}>{dataItem.docID}</span>
                      </td>
                      <td >{dataItem.audience}</td>
                      <td >{dataItem.title}</td>
                      <td >{dataItem.body.split(" ").splice(0, 8).join(" ") + "..."}</td>
                      <td data-tooltip={`DATA/HORA DE CRIAÇÃO ${formatDate(dataItem.dateSend)}`}>
                        {`${formatDate(dataItem.dateSchedule)}`}
                      </td>
                      <td className="link-center">
                        <a href={dataItem.url} data-tooltip={`${dataItem.url}`} target="_blank">
                          <FiExternalLink />
                        </a>
                      </td>
                      <td >{dataItem.status}</td>
                      {dataItem.recurrence ?
                        <td
                          data-tooltip={`${recurrenceTooltip(dataItem)}`}>
                          {translate[dataItem.recurrence]}
                        </td>
                        : <td >{translate[dataItem.recurrence]}</td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </main>
  );
};

export default WebPushAgendamentos2;
